module.exports = __webpack_public_path__ + "static/media/edit.99309653.svg";